export const HIDE_LOADER = 'HIDE_LOADER'
export const SHOW_LOADER = 'SHOW_LOADER'

export const OPEN_LEFT_NAVIGATION = 'OPEN_LEFT_NAVIGATION'
export const CLOSE_LEFT_NAVIGATION = 'CLOSE_LEFT_NAVIGATION'

export const GET_USER_SESSION_TOKEN = 'GET_USER_SESSION_TOKEN'
export const GET_USER_SESSION_TOKEN_FAILED = 'GET_USER_SESSION_TOKEN_FAILED'
export const GET_USER_SESSION_TOKEN_SUCCEEDED = 'GET_USER_SESSION_TOKEN_SUCCEEDED'

export const ENABLE_PAGE_MODE_LOADER = 'ENABLE_PAGE_MODE_LOADER'
export const DISABLE_PAGE_MODE_LOADER = 'DISABLE_PAGE_MODE_LOADER'

export const FETCH_USER_FINANCIAL_DATA = 'FETCH_USER_FINANCIAL_DATA'
export const FETCH_USER_FINANCIAL_DATA_FAILED = 'FETCH_USER_FINANCIAL_DATA_FAILED'
export const FETCH_USER_FINANCIAL_DATA_SUCCESS = 'FETCH_USER_FINANCIAL_DATA_SUCCESS'
